export class AdFieldOption {
  value: string;
  label: string;

  constructor() {
    this.value = null;
    this.label = null;
  }
}
